import React from 'react';
import { LockIcon } from 'lucide-react';
export function GuaranteeBadge() {
  return <div className="flex flex-col items-center" data-id="element-294">
      <div className="relative" data-id="element-295">
        <div className="w-24 h-24 rounded-full bg-teal-600 flex items-center justify-center mb-3" data-id="element-296">
          <LockIcon className="w-10 h-10 text-white" data-id="element-297" />
        </div>
        <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-md" data-id="element-298">
          <span className="text-teal-600 text-lg font-bold" data-id="element-299">✓</span>
        </div>
      </div>
      <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-300">30-Day Guarantee</h3>
      <p className="text-sm text-gray-600 text-center max-w-xs" data-id="element-301">
        Try it risk-free. If you're not satisfied, we'll refund your purchase.
      </p>
    </div>;
}